<template>
  <div>
    <HMModalHeader
      :title="$t('GENERAL.TITLE.RENAME')"
      @close="$emit('close')"
    />
    <ValidationObserver ref="form">
      <form @submit.prevent="submit">
        <div class="row">
          <div class="col-12">
            <HMTextInput
              type="text"
              rules="required"
              v-model="localValue"
              name="value"
            />
          </div>
        </div>
        <HMModalFooter
          class="mt-3"
          :submitButton="$t('GENERAL.BUTTON.CONFIRM')"
          :discardButton="$t('GENERAL.BUTTON.CANCEL')"
          @close="$emit('close')"
        />
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate';

export default {
  name: 'HMRenameModal',
  components: {
    ValidationObserver,
  },
  props: {
    value: {
      type: String,
    },
    title: {
      type: String,
      default: 'GENERAL.TITLE.RENAME',
    },
  },
  data() {
    return {
      localValue: '',
    };
  },
  methods: {
    async submit() {
      this.$parent.$emit('renamed', this.localValue);
      this.$emit('close');
    },
  },
  mounted() {
    this.localValue = this.value;
  },
};
</script>
